import CardIndicadoresOperacao from "./CardIndicadoresOperacao";
import DashSectionTitle from "./v2/DashSectionTitle";

const FinancialArea = () => (
  <div id="financeiro">
    <DashSectionTitle title="Operação" subtitle="Indicadores de operação por vendedor" />
    <div className="dash-grid">
      <CardIndicadoresOperacao />
    </div>
  </div>
);

export default FinancialArea;
